import { Navigate, Outlet } from 'react-router-dom'

type Props = {
  isAuthenticated: boolean
}

export function NotAuthenticatedRoute({ isAuthenticated }: Props) {
  if (isAuthenticated) return <Navigate to="/" replace />

  return (
    <>
      <Outlet />
    </>
  )
}
